export default __webpack_public_path__ + "static/media/mobile-add-on-min.755ae6cf.png";